import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import Input from 'v2/form/Input/Input';
import TextArea from 'v2/form/TextArea/TextArea';
import { SignUpFlowFormData } from './SignUpFlow';

const companyTypeExamples = [
  'Investment Firm',
  'Consulting Firm',
  'Software Company',
];
interface StepTwoProps {
  register: UseFormRegister<SignUpFlowFormData>;
  errors: FieldErrors<SignUpFlowFormData>;
}

const StepThree = ({ register, errors }: StepTwoProps) => {
  return (
    <div>
      <FormGroup className="mt-4">
        <Input
          label="Company Name"
          type="text"
          register={register('firm_name', { required: true })}
          error={errors?.firm_name?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:company-name"
        />
      </FormGroup>

      <FormGroup className="mt-4">
        <Input
          label="Company Type"
          type="text"
          register={register('firm_type', { required: true })}
          error={errors?.firm_type?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:company-type"
        />
        <p className="mb-1 text-light2 font-14">Examples:</p>
        <ul className="pl-3">
          {companyTypeExamples.map((item) => (
            <li key={item} className="text-light2 font-14">
              {item}
            </li>
          ))}
        </ul>
      </FormGroup>

      <FormGroup className="mt-4">
        <Input
          label="Company Website Address"
          type="text"
          register={register('website', { required: true })}
          error={errors?.website?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:company-web-address"
        />
      </FormGroup>
      <FormGroup className="mt-4">
        <TextArea
          label="1-2 Sentence summary of your company"
          register={register('short_description', { required: true })}
          error={errors?.short_description?.message}
          autoComplete="off"
          required={true}
          rows={4}
          data-cy="signup:company-sentence-summary"
        />
      </FormGroup>
    </div>
  );
};

export default StepThree;
